<template>
  <div>
    <app-layout>
      <template v-slot:header>
        <Header :isFilter="false"
                :title="$t('mentora_transfer_out_request_detail')"/>
      </template>
      <template v-slot:header-mobile>
        <HeaderMobile :isFilter="false"
                      :title="$t('mentora_transfer_out_request_detail')"/>
      </template>
      <div v-if="transferOutFormData.id">
        <div class="row">
          <div class="col-12">
            <div class="mb-4">
              <h6 class="text-uppercase mb-0">
                {{ toUpperCase('application_information') }}
              </h6>
            </div>
          </div>
          <div class="col-12">
            <b-row>
              <div class="col-12">
                <div class="border rounded p-4 mb-3 h-100">
                  <div class="mb-4">
                    <h6 class="text-uppercase mb-0">
                      {{ $t('student_information').toUpper() }}
                    </h6>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                      <b-form-group :label="$t('student_id')">
                        <span>{{ transferOutFormData.student_number }}</span>
                    </b-form-group>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                      <b-form-group :label="$t('full_name')">
                        <span>{{ transferOutFormData.name + ' ' + transferOutFormData.surname }}</span>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                      <b-form-group :label="$t('reason')">
                        <span>{{ transferOutFormData.reason }}</span>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                      <b-form-group :label="$t('explanation')">
                        <span>{{ transferOutFormData.explanation }}</span>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                      <b-form-group :label="$t('new_institution')">
                        <span>{{ transferOutFormData.new_institution_name }}</span>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                      <b-form-group :label="$t('sevis_school_code')">
                        <span>{{ transferOutFormData.school_sevis_code }}</span>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                      <b-form-group :label="$t('starting_date_new_institution')">
                        <span>{{ transferOutFormData.program_start_date }}</span>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                      <b-form-group :label="$t('status')">
                        <span>{{ transferOutFormData.status_name }}</span>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                        <b-form-group :label="$t('acceptance_letter_file')">
                            <div v-if="transferOutFormData.acceptance_letter_file">
                                <span class="mr-3 mb-1 d-inline-block">{{ transferOutFormData.acceptance_letter_file.file_name }}</span>
                                <div class="d-inline-block">
                                    <a href="javascript:;"
                                       @click="download(transferOutFormData.acceptance_letter_file)">
                                        <i class="ri-download-2-line mr-1 top-plus-1"></i> {{ $t('download') }}
                                    </a>
                                </div>
                            </div>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                        <b-form-group :label="$t('eligibility_file')">
                            <div v-if="transferOutFormData.eligibility_file">
                                <span class="mr-3 mb-1 d-inline-block">{{ transferOutFormData.eligibility_file.file_name }}</span>
                                <div class="d-inline-block">
                                    <a href="javascript:;"
                                       @click="download(transferOutFormData.eligibility_file)">
                                        <i class="ri-download-2-line mr-1 top-plus-1"></i> {{ $t('download') }}
                                    </a>
                                </div>
                            </div>
                        </b-form-group>
                    </div>
                  </div>

                </div>
              </div>
            </b-row>
          </div>
        </div>
        <div v-if="selectedActiveStep" class="mt-3">
          <h6 class="text-uppercase mb-4">{{ $t('approval_procedures').toUpper() }}</h6>
            <div v-if="approvalType === 'admin-review'">
                <admin-review-form :formId="formId"
                                   @updateFormSuccess="updateFormSuccess"/>
            </div>
            <div v-else-if="approvalType === 'dso'">
              <dso-releases-form :formId="formId"
                                 :activeStep="activeStep"
                                 @updateFormSuccess="updateFormSuccess"/>
            </div>
            <div v-else-if="approvalType === 'update'">
                <update-step-form :formId="formId"
                                  :activeStep="activeStep"
                                  @updateFormSuccess="updateFormSuccess"/>
            </div>
        </div>
        <div v-if="steps && steps.length && Object.assign(steps).length" class="mt-3">
          <b-table :empty-text="$t('there_are_no_records')" :fields="[
                            { key: 'rank', label: this.toUpperCase('rank'), thClass: 'text-center', tdClass: 'text-center' },
                            { key: 'approvers', label: this.toUpperCase('can_approvers'), thClass: 'text-center' },
                            { key: 'approved', label: this.toUpperCase('approved_by'), thClass: 'text-center' },
                            { key: 'status', label: this.toUpperCase('status'), thClass: 'text-center' },
                            { key: 'reason', label: this.toUpperCase('explanation'), thClass: 'text-center' },
                            { key: 'updated_at', label: this.toUpperCase('updated_at'), thClass: 'text-center' }
                        ]" :items="steps" bordered class="mb-3 table-dropdown no-scrollbar border rounded"
                   responsive show-empty sort-by="rank" striped>
            <template #cell(approvers)="data">
                            <span v-for="(approver, key) in data.item.approvers" :key="key">
                                {{ approver.explanation }} <br>
                            </span>
            </template>
            <template #cell(approved)="data">
                            <span v-for="(approver, key) in data.item.approved" :key="key">
                                {{ approver.name }} {{ approver.surname }}<br>
                            </span>
            </template>
            <template #cell(status)="data">
              {{ data.item.status_name }}
            </template>
          </b-table>
        </div>
      </div>
    </app-layout>
  </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";

import {ValidationProvider, ValidationObserver} from "vee-validate"
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox.vue";
import LoadingButton from "@/components/elements/LoadingButton.vue";
import YesNoSelectbox from "@/components/interactive-fields/YesNoSelectbox.vue";
import ApprovedDeclinedSelectbox from "@/components/interactive-fields/ApprovedDeclinedSelectbox.vue";
import TransferOutRequestMentora from "@/services/TransferOutRequestMentora";
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import PreEvaluateForm from "@/modules/tuitionAssistanceRequest/pages/PreEvaluateForm.vue";
import AdminReviewForm from "@/modules/transferOutFormMentora/pages/admin/approvalProcedures/AdminReviewForm.vue";
import UpdateStepForm from "@/modules/transferOutFormMentora/pages/admin/approvalProcedures/UpdateStepForm.vue";
import DsoReleasesForm from "@/modules/transferOutFormMentora/pages/admin/approvalProcedures/DsoReleasesForm.vue";

export default {
  components: {
    DsoReleasesForm,
    UpdateStepForm,
    ApprovedDeclinedSelectbox,
    YesNoSelectbox,
    LoadingButton,
    MultiSelectbox,
    AppLayout,
    Header,
    HeaderMobile,
    ValidationProvider,
    ValidationObserver,
    AdminReviewForm,
    PreEvaluateForm,
    ProcessingButton,
  },
    props: {
        formId: {
            type: Number,
            required: true
        }
    },
  data() {
    return {
        form: {},
        updateStep: {
            status: null
        },
        transferOutFormData: {},
        step: {},
        steps: {},
        statuses: {},
        isLoading: false,
        isUpdateStep: false
    }
  },

  metaInfo() {
    return {
      title: this.$t('mentora_time_of_request_detail')
    }
  },
  computed: {
    userRole() {
        return this.$store.getters['auth/getActiveRole']
    },
    selectedActiveStep() {
        if (this.steps && this.steps.length > 0) {
            const activeStep = this.steps.filter((item) => item.active)
            return activeStep[0]?.approvers?.[0].name === this.userRole
        } else {
            return false
        }
    },
    approvalType() {
      if (this.step.name==='Mentora Admission Officer') {
          return 'admin-review'
      }
      if (this.step.name === 'DSO Approval') {
          return 'dso'
      }

      if(this.step){
        return 'update';
      }

      return null
    },
    activeStep() {
      return this.steps.find(item => item.active)
    }
  },
  created() {
    this.getMentoraTimeOfRequest();
  },
  methods: {
    updateFormSuccess() {
        this.getMentoraTimeOfRequest()
    },
    getMentoraTimeOfRequest() {
      TransferOutRequestMentora.show(this.formId)
          .then(response => {
            this.transferOutFormData = response.data.data;
            this.transferOutFormData.amount_due = Number(response.data.data.amount_due)
            this.transferOutFormData.eligible_duration = Number(response.data.data.eligible_duration)
            this.step = this.transferOutFormData.step == null ? {} : this.transferOutFormData.step;
            this.steps = this.transferOutFormData.steps;
          })
          .catch(e => {
            this.$toast.error(e.data.message)
          })

    },
    async update() {
      const isValid = await this.$refs.formObserver.validate();
      if (isValid) {
        this.$swal.fire({
          title: this.$t('warning'),
          text: this.$t('leave_of_absence_statement'),
          showCancelButton: true,
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no'),
        }).then((result) => {
          this.isLoading = true
          if (result.isConfirmed) {
            this.transferOutFormData.attended_all_classes_after_prev_time_off = this.transferOutFormData.attended_all_classes_after_prev_time_off === 'Yes' ? 1 : 0
            this.transferOutFormData.good_standing = this.transferOutFormData.good_standing === 'Yes' ? 1 : 0
            this.transferOutFormData.on_probation = this.transferOutFormData.on_probation === 'Yes' ? 1 : 0
            TransferOutRequestMentora.updateStep(this.formId, this.transferOutFormData)
                .then(response => {
                  this.$toast.success(this.$t('api.' + response.data.message));
                  this.getMentoraTimeOfRequest()
                })
                .catch(error => {
                  this.showErrors(error, this.$refs.formObserver)
                }).finally(this.isLoading = false);
          }
        })
      }
    },
    download(file) {
        if(this.checkPermission('transferoutrequest_download')){
            TransferOutRequestMentora.downloadFile(file.uuid)
                .then(response => {
                    this._downloadFile(response, file.file_name);
                })
                .catch(error => {
                    if (error.status == 422) {
                        this.$toast.error(error.data.errors.file[0]);
                    }
                    if (error.status == 406) {
                        this.$toast.error(this.$t('api.' + error.data.message));
                    }
                });
        } else {
            this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
        }
    },

  },
};
</script>
